import { render, staticRenderFns } from "./ProjektHeadlineLabel.vue?vue&type=template&id=421de346&"
import script from "./ProjektHeadlineLabel.vue?vue&type=script&lang=js&"
export * from "./ProjektHeadlineLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports